import React from 'react';
import { Button } from './ui/button';

const Header = () => {
  const handleSubscribe = () => {
    // Track Subscribe event with Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Subscribe', {
        source: 'header',
        value: 1,
        currency: 'USD'
      });
    }
    window.open('https://t.me/sinyalbankentry/12328', '_blank');
  };

  return (
    <header className="bg-black border-b border-gray-800 py-4 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <img src="https://customer-assets.emergentagent.com/job_signal-bank/artifacts/vfj5iyv4_cropped_circle_image-modified.png" alt="SBE Logo" className="w-10 h-10 rounded-full" />
            <span className="text-white font-bold text-xl">Sinyal Bank Entry</span>
          </div>
          <Button 
            onClick={handleSubscribe}
            className="bg-[#ED1C24] hover:bg-[#c91820] text-white px-6 py-2 rounded-lg font-semibold transition-all hover:scale-105"
          >
            Join Sekarang
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;